export default __webpack_public_path__ + "static/media/ryan.ca24473b.jpg";